import React from 'react';
import { Button, Grid, TextField } from "@material-ui/core";
import { validationMessages, requiredOnlyMessage, patternOnly } from '../../../config/validations';
import { Controller } from "react-hook-form";
import DatePickerField from '../../atoms/Wrappers/datePicker'
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    textField: {
        height: '40px',
        '& .MuiInputLabel-shrink': {
            transform: 'translate(0, -50%)',
        },
    },
}));

export default function SearchField({ form, handleBackUpSearch, searchInProgress }) {
    const { register, handleSubmit, formState: { errors }, control } = form;

    const messages = {
        ...validationMessages,
        ...requiredOnlyMessage,
    };



    return (
        <Grid container direction={"row"} spacing={2} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}} >

            <Grid item xs={8}>
                <TextField
                    name="keyword"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    size={'small'}
                    inputRef={register({ ...patternOnly })}
                    error={errors?.keyword ? true : false}
                    helperText={errors?.keyword ? messages[errors?.keyword?.type] : ''}
                />
            </Grid>
            <Grid item xs={2} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <Controller
                    name="date"
                    control={control}
                    defaultValue={false}
                    render={({ field, value, onChange }) =>
                        <DatePickerField
                            id='dateFilter'
                            name='dateFilter'
                            label='Date'
                            handleDatePicker={e => { onChange(e) }}
                            value={value}
                        />
                    }
                />
            </Grid>
            <Grid item xs={2} style={{display: 'flex', justifyContent: 'flex-end'}} >
                <Button onClick={handleSubmit(handleBackUpSearch)} disabled={searchInProgress} color="primary" variant="contained" style={{ minWidth: '100%', textTransform: 'capitalize' }}>
                    {searchInProgress ? 'Searching..' : 'Search'}
                </Button>
            </Grid>
                    {/* style={{ display: "flex", justifyContent: "flex-start", marginBottom: 20 }} */}

        </Grid>
    )
}


export const SearchTextField = (props) => {
    const { setSearchQuery, searchQuery } = props;

    const classes = useStyles();

    function handleSearchInputChange(event) {
        setSearchQuery(event.target.value);
    }

    function handleClearSearch() {
        setSearchQuery('');
    }

    return (
        <Grid container direction={"row"} spacing={3} >
            <Grid id={"search-input-container"} item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <TextField
                    id="search_input"
                    label="Search"
                    variant="outlined"
                    // className={classes.textField}
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                    style={{ marginBottom: 20 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton color="primary" id="search_btn" aria-label="upload picture" component="span" onClick={handleClearSearch}>
                                    {searchQuery.length == 0 ? <SearchIcon /> : <CloseIcon />}
                                </IconButton>
                            </InputAdornment>
                        ),
                        style: {
                            // height: '40px', // Set the height to 40px
                            width: 350
                        },
                    }}
                />
            </Grid>
        </Grid>
    )



}